// extracted by mini-css-extract-plugin
export default {"self":"TaskAssignment-module-d0f2ab76b02b3abcef41","taskIcon":"TaskAssignment-module-e952c31118810b8f7a7e"};